module.exports = __webpack_public_path__ + "static/employee_joh-29327879af31587310df2f1074a3ef79.jpg";